import React from "react";
import { createUseStyles, useTheme } from "react-jss";

import styles from "./styles";

interface Props {
  children: React.ReactNode;
}

const Accordion = (props: Props) => {
  const { children } = props;
  const useStyles = createUseStyles(styles);
  const theme = useTheme();
  const classes = useStyles({
    theme,
    ...props,
  });

  return <div className={classes.accordion}>{children}</div>;
};

export default Accordion;
